import React from 'react';
import { Redirect } from 'react-router-dom';
import { AppParams } from 'src/api/applicationParams';
import { useApplicationParams } from './useApplicationParams';

type State = {
  isAllowed: boolean | null;
  loading: boolean;
  error: unknown;
};

type RedirectFn = (path: string) => JSX.Element | null;

export const useAppPermission = (appId: string, appParams: AppParams.Name[]): [State, RedirectFn] => {
  const { data, loading, error } = useApplicationParams({
    appId,
    appParams,
    defaultValue: false as boolean,
  });
  const redirect = (path: string): JSX.Element | null => {
    if (data === null) {
      return null;
    }
    return <Redirect to={path} />;
  };
  const isAllowed = data ? appParams.every((name) => data[name]) : null;
  return [{ isAllowed, loading, error }, redirect];
};
